import FastMarquee from "react-fast-marquee";

const ITEMS = ["SOCCER", "FOOTBALL", "BASKETBALL", "WORLD CHAMPIONS", "LEGENDS", "STREETWEAR"];

export default function Marquee() {
  return (
    <div data-testid="marquee" className="bg-primary py-4 border-y border-black overflow-hidden">
      <FastMarquee autoFill speed={45} gradient={false}>
        {ITEMS.map((t) => (
          <span key={t} className="font-anton text-3xl md:text-5xl uppercase tracking-tight text-black mx-6 inline-flex items-center gap-6">
            {t}
            <span className="w-3 h-3 bg-black rotate-45 inline-block" />
          </span>
        ))}
      </FastMarquee>
    </div>
  );
}
